"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsHeaderDropdownInner = exports.TabsHeaderDropdown = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _useStyles = require("../../helpers/useStyles");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useOutsideClick = require("../../helpers/useOutsideClick");

var _classnames = _interopRequireDefault(require("classnames"));

var _usePropsUpdatedChildren = require("../../helpers/usePropsUpdatedChildren");

var _tab = require("./tab");

var _SvgIconDownFilled = require("../svg/feathers/SvgIconDownFilled");

var _dropdown = require("../dropdown");

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

(0, _loadStyles.default)(".ca881e0a7{display:flex}.c4c511049{display:flex}.cd5532835{box-shadow:0 .0625rem 0 var(--color-gray-20);margin-bottom:.0625rem}.cc866b10a{margin:0;padding:.5rem .625rem;list-style-type:none;width:15.625rem;box-sizing:border-box}.c5e252f3e:not(:last-child){margin-bottom:.563rem}.c2ec9a2ff{padding:0;background:0 0;border:0}.c2e769dcb{white-space:nowrap;display:flex;position:relative;width:100%}.cd3551afa{position:absolute;right:0;color:var(--color-gray-80);transition:all ease-in-out .3s}.cd3551afa:hover{cursor:pointer}.cd3dbaab9{-webkit-transform:rotateX(180deg);transform:rotateX(180deg)}.c1e906e02:hover{cursor:pointer}");
var styles = {
  root: 'ca881e0a7',
  displayedTabs: 'c4c511049',
  '--view-secondary': 'cd5532835',
  moreMenu: 'cc866b10a',
  moreMenuItem: 'c5e252f3e',
  moreMenuTabItem: 'c2ec9a2ff',
  moreButton: 'c2e769dcb',
  moreIcon: 'cd3551afa',
  moreIconActive: 'cd3dbaab9',
  activeMoreTab: 'c1e906e02'
};

var TabsHeaderDropdown = function TabsHeaderDropdown(props) {
  return /*#__PURE__*/_react.default.createElement(TabsHeaderDropdownInner, props);
};

exports.TabsHeaderDropdown = TabsHeaderDropdown;

var TabsHeaderDropdownInner = function TabsHeaderDropdownInner(props) {
  var children = props.children,
      classes = props.classes,
      view = props.view;
  var elementTypes = (0, _react.useMemo)(function () {
    return [_tab.Tab];
  }, []);
  var updateFunc = (0, _react.useCallback)(function (oldProps) {
    return !oldProps ? {
      view: view
    } : _objectSpread(_objectSpread({}, oldProps), {}, {
      view: view
    });
  }, [view]);

  var _usePropsUpdatedChild = (0, _usePropsUpdatedChildren.usePropsUpdatedChildrenWithShouldUpdate)(children, elementTypes, updateFunc),
      updatedChildren = _usePropsUpdatedChild.updatedChildren,
      shouldUpdate = _usePropsUpdatedChild.shouldUpdate;

  var cn = (0, _useStyles.useStyles)(styles, classes);

  var _useState = (0, _react.useState)(updatedChildren),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      displayedTabs = _useState2[0],
      setDisplayedTabs = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      activeMoreTab = _useState4[0],
      setActiveMoreTab = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isMoreTabMenuOpen = _useState6[0],
      setIsMoreTabMenuOpen = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      moreTabsList = _useState8[0],
      setMoreTabsList = _useState8[1];

  var _useState9 = (0, _react.useState)(true),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      isMoreButtonDisplayed = _useState10[0],
      setIsMoreButtonDisplayed = _useState10[1];

  var tabsHeaderRef = (0, _react.useRef)(null);
  var moreButtonRef = (0, _react.useRef)(null);
  var moreIconRef = (0, _react.useRef)(null);
  var moreMenuRef = (0, _react.useRef)(null);
  var displayedTabsRefs = (0, _react.useRef)([]);
  var isTabDisplayed = (0, _react.useCallback)(function (tab) {
    if (tab) {
      var tabsLabels = _react.default.Children.map(displayedTabs, function (tab) {
        return tab.props.children;
      });

      return tabsLabels.includes(tab.props.children);
    }

    return false;
  }, [displayedTabs]);
  (0, _react.useEffect)(function () {
    if (shouldUpdate) {
      setDisplayedTabs(function (prevDisplayedTabs) {
        return updatedChildren.filter(function (item) {
          return prevDisplayedTabs.find(function (displayedItem) {
            return displayedItem.props.children === item.props.children;
          });
        });
      });
    }
  }, [shouldUpdate, updatedChildren]);
  (0, _react.useLayoutEffect)(function () {
    var tabs = displayedTabsRefs.current.filter(function (ref) {
      return ref !== null;
    });
    var displayedTabsWidth = tabs.reduce(function (acc, tab) {
      if (tab) {
        return acc + tab.getBoundingClientRect().width;
      }

      return acc;
    }, 0);

    if (tabsHeaderRef.current && moreButtonRef.current && moreIconRef.current) {
      var tabsHeaderWidth = tabsHeaderRef.current.getBoundingClientRect().width;
      var moreButtonWidth = moreButtonRef.current.getBoundingClientRect().width;
      var moreIconWidth = moreIconRef.current.getBoundingClientRect().width;
      var availableSpace = tabsHeaderWidth - moreButtonWidth - moreIconWidth;

      if (tabs.length > 1 && availableSpace < displayedTabsWidth) {
        var numberOfTabsToRemove = 0;

        while (availableSpace < displayedTabsWidth) {
          numberOfTabsToRemove += 1;
          displayedTabsWidth -= tabs[tabs.length - numberOfTabsToRemove].getBoundingClientRect().width;
        }

        if (numberOfTabsToRemove > 0) {
          setDisplayedTabs(function (prevTabs) {
            return prevTabs.slice(0, prevTabs.length - numberOfTabsToRemove);
          });

          var _tabs = updatedChildren.slice(displayedTabs.length - numberOfTabsToRemove, updatedChildren.length);

          if (activeMoreTab !== '') {
            _tabs = _tabs.filter(function (tab) {
              return activeMoreTab.props.children !== tab.props.children;
            });
          }

          setMoreTabsList(_tabs);
        }
      }
    }
  }, [updatedChildren, displayedTabs, activeMoreTab]);
  (0, _react.useLayoutEffect)(function () {
    setIsMoreButtonDisplayed(moreTabsList.length > 0);
  }, [moreTabsList]);

  var moreTabClickHandler = function moreTabClickHandler(activeTab) {
    var tab = (0, _toConsumableArray2.default)(updatedChildren).filter(function (tab) {
      return tab.props.children === activeTab.props.children;
    });
    setActiveMoreTab.apply(void 0, (0, _toConsumableArray2.default)(tab));
    setIsMoreTabMenuOpen(false);
    setDisplayedTabs(updatedChildren);
  };

  var closeHandler = (0, _react.useCallback)(function () {
    return setIsMoreTabMenuOpen(false);
  }, []);
  var outsideClickHandler = (0, _react.useMemo)(function () {
    return (0, _useOutsideClick.getOutsideClickHandler)(moreMenuRef, closeHandler);
  }, [closeHandler]);
  var onOverlayClickHandler = (0, _react.useCallback)(function () {
    setIsMoreTabMenuOpen(false);
  }, []);
  var onMoreIconClickHandler = (0, _react.useCallback)(function () {
    setIsMoreTabMenuOpen(true);
  }, []);
  (0, _useOutsideClick.useOutsideClick)(outsideClickHandler, isMoreTabMenuOpen);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: tabsHeaderRef,
    className: (0, _classnames.default)(cn.root, cn.view[view])
  }, _react.default.Children.map(displayedTabs, function (displayedTab, index) {
    return /*#__PURE__*/_react.default.cloneElement(displayedTab, {
      ref: function ref(_ref) {
        return displayedTabsRefs.current[index] = _ref;
      }
    });
  }), isMoreButtonDisplayed && /*#__PURE__*/_react.default.createElement("div", {
    className: cn.moreButton
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: moreButtonRef,
    className: cn.activeMoreTab
  }, !isTabDisplayed(activeMoreTab) && activeMoreTab), /*#__PURE__*/_react.default.createElement("div", {
    ref: moreIconRef,
    onClick: onMoreIconClickHandler,
    className: (0, _classnames.default)(cn.moreIcon, isMoreTabMenuOpen && cn.moreIconActive)
  }, /*#__PURE__*/_react.default.createElement(_SvgIconDownFilled.SvgIconDownFilled, null))), /*#__PURE__*/_react.default.createElement(_dropdown.Dropdown, {
    position: "right",
    variation: "secondary",
    active: isMoreTabMenuOpen,
    onOverlayClick: onOverlayClickHandler
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: cn.moreMenu
  }, moreTabsList.map(function (tab, i) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: i,
      className: cn.moreMenuItem
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: cn.moreMenuTabItem,
      onClick: function onClick() {
        moreTabClickHandler(tab);
      }
    }, tab));
  }))));
};

exports.TabsHeaderDropdownInner = TabsHeaderDropdownInner;
TabsHeaderDropdownInner.propTypes = {
  children: _propTypes.node.isRequired,
  classes: (0, _getClassesPropType.getClassesPropType)(styles),
  view: _propTypes.string.isRequired
};
TabsHeaderDropdownInner.defaultProps = {
  classes: {}
};